import { render, staticRenderFns } from "./LunchOption.vue?vue&type=template&id=79c45cb4&"
import script from "./LunchOption.vue?vue&type=script&lang=js&"
export * from "./LunchOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports